import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AlertCard = ({ alert, onDismiss }) => {
  const getSeverityConfig = (severity) => {
    const configs = {
      'critical': {
        bg: 'bg-error/10 border-error',
        icon: 'AlertTriangle',
        iconColor: 'text-error',
        badge: 'bg-error text-error-foreground'
      },
      'high': {
        bg: 'bg-warning/10 border-warning',
        icon: 'AlertCircle',
        iconColor: 'text-warning',
        badge: 'bg-warning text-warning-foreground'
      },
      'medium': {
        bg: 'bg-info/10 border-info',
        icon: 'Info',
        iconColor: 'text-info',
        badge: 'bg-info text-info-foreground'
      },
      'low': {
        bg: 'bg-muted border-border',
        icon: 'Bell',
        iconColor: 'text-muted-foreground',
        badge: 'bg-muted text-muted-foreground'
      }
    };
    return configs?.[severity] || configs?.low;
  };

  const config = getSeverityConfig(alert?.severity);

  return (
    <div className={`bg-white dark:bg-gray-800 ${config?.bg} border-l-4 rounded-lg p-5 shadow-conservation`}>
      <div className="flex items-start gap-4">
        <div className={`${config?.iconColor} mt-1`}>
          <Icon name={config?.icon} size={24} />
        </div>
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            <h3 className="text-base font-semibold text-gray-900 dark:text-white">{alert?.title}</h3>
            <span className={`${config?.badge} px-2 py-0.5 rounded text-xs font-medium uppercase`}>
              {alert?.severity}
            </span>
          </div>
          <p className="text-sm text-gray-500 dark:text-gray-400">{alert?.zone} • {alert?.timestamp}</p>
          
          <p className="text-sm text-gray-600 dark:text-gray-300 mb-3">{alert?.description}</p>
          
          {alert?.affectedVisitors > 0 && (
            <div className="flex items-center gap-2 mb-4 text-sm text-gray-600 dark:text-gray-300">
              <Icon name="Users" size={16} />
              <span>{alert?.affectedVisitors} visitors affected</span>
            </div>
          )}

          {alert?.actions && alert?.actions?.length > 0 && (
            <div className="flex flex-wrap gap-2">
              {alert?.actions?.map((action, index) => (
                <Button key={index} variant="outline" size="sm">
                  {action}
                </Button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AlertCard;